<template>
  <div class="phone-details" data-cy="pay-in-person-phone-screen">
    <NavHeader
      @onBackClick="goBack"
      :title="$t('components.notificationModal.phoneNumberLabel')"
    />
    <div v-if="isLoading" class="loader">
      <v-progress-circular indeterminate />
    </div>
    <div v-else>
      <LayoutCard
        rounded
        :title="$t('screens.payInPersonSuccess.smsDisclaimerTitle')"
      >
        <div class="tp-text-body">
          {{ $t('screens.payInPersonSuccess.smsDisclaimer') }}
        </div>
        <div ref="phoneInputWrapper" class="phone-input pt-4">
          <vue-phone-number-input
            ref="phoneInput"
            v-model="phoneNumber"
            no-flags
            :color="'#000000'"
            :default-country-code="locale"
            size="lg"
            :translations="{
              countrySelectorLabel: $t(
                'components.notificationModal.countrySelectorLabel'
              ),
              countrySelectorError: $t(
                'components.notificationModal.countrySelectorError'
              ),
              phoneNumberLabel: $t(
                'components.notificationModal.phoneNumberLabel'
              ),
              example: $t('components.notificationModal.example'),
            }"
            no-example
            @update="onNumberChange"
          />
          <div class="tp-text-label black--text mt-4">
            <span>
              {{ $t('screens.order.notificationsModalBodySMS') }}
            </span>
          </div>
        </div>
      </LayoutCard>
      <div class="px-10">
        <Button
          dark
          :disabled="!isValid || isSubmitting"
          :loading="isSubmitting"
          data-cy="pay-in-person-phone-continue"
          @click="continueToPayment"
        >
          {{ $t('generic.continue') }}
        </Button>
        <Button
          class="mt-4 text-black"
          white
          :disabled="isSubmitting"
          data-cy="pay-in-person-phone-skip"
          @click="skip"
        >
          {{ $t('generic.notNow') }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import NavHeader from '@/components/Navigation/NavHeader.vue';
import LayoutCard from '@/components/LayoutCard.vue';
import Button from '@/components/Button.vue';

export default {
  name: 'PayInPersonPhone',
  components: {
    NavHeader,
    LayoutCard,
    Button,
  },
  data() {
    return {
      phoneNumber: null,
      nationalNumber: null,
      countryCallingCode: null,
      isValid: false,
      isSubmitting: false,
      isLoading: true,
    };
  },
  computed: {
    session() {
      return this.$route.params.session;
    },
    order() {
      return this.$route.params.order;
    },
    locale() {
      const localeCode = this.$store.state.locale?.locale_code || 'lt-LT';
      return localeCode.split('-')[1];
    },
    pendingPhone() {
      return this.$store.getters.getPendingPayInPersonPhone;
    },
  },
  async mounted() {
    const sessionToken = this.session;

    await this.$store.dispatch('fetchSessionData', { session: sessionToken });

    this.isLoading = false;

    this.$nextTick(() => {
      this.prefillPhoneIfAvailable();
      this.focusInput();
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onNumberChange({ isValid, countryCallingCode, nationalNumber }) {
      this.countryCallingCode = countryCallingCode;
      this.isValid = isValid;
      this.nationalNumber = nationalNumber;
    },
    focusInput() {
      if (typeof window === 'undefined') {
        return;
      }

      const wrapper = this.$refs.phoneInputWrapper;
      if (!wrapper) return;

      const phoneInputComponent = this.$refs.phoneInput;
      const input =
        phoneInputComponent?.$el?.querySelector('input[type="tel"]') ||
        wrapper.querySelector('input[type="tel"]') ||
        phoneInputComponent?.$el?.querySelector('input') ||
        wrapper.querySelector('input');

      if (!input) return;

      input.focus();
    },
    prefillPhoneIfAvailable() {
      const pending = this.pendingPhone;

      if (
        pending &&
        pending.countryCallingCode &&
        pending.nationalNumber
      ) {
        this.countryCallingCode = pending.countryCallingCode;
        this.nationalNumber = pending.nationalNumber;
        this.isValid = true;
        this.phoneNumber = `+${pending.countryCallingCode}${pending.nationalNumber}`;
        return;
      }
    },
    async continueToPayment() {
      if (!this.countryCallingCode || !this.nationalNumber || !this.isValid) {
        return;
      }

      this.isSubmitting = true;

      try {
        await this.$store.dispatch('setPendingPayInPersonPhone', {
          countryCallingCode: this.countryCallingCode,
          nationalNumber: this.nationalNumber,
        });

        this.navigateToPayInPerson();
      } finally {
        this.isSubmitting = false;
      }
    },
    skip() {
      this.navigateToPayInPerson();
    },
    navigateToPayInPerson() {
      this.$router.push({
        name: 'PayInPerson',
        params: {
          session: this.session,
          order: this.order,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.phone-details {
  padding-bottom: 100px;
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.phone-input::v-deep {
  .country-selector {
    .country-selector__list__item {
      font-size: 16px !important;
    }

    &__list {
      z-index: 333;
      height: 150px !important;
    }
  }

  .vue-phone-number-input {
    input {
      font-size: 16px !important;
    }
  }
}
</style>

